import { env } from './env';
import { getParameterByName } from './util';
import { getUuidFromJwt } from './jwt';
import { isUuidSampled } from './sampling';

export function shouldShowNewDesign(): boolean {
  if (getParameterByName('redesign') === 'true') {
    return true;
  }

  const paymentId = getUuidFromJwt(getParameterByName('token'));
  if (!paymentId) {
    return false;
  }

  return isUuidSampled(paymentId, env.VITE_FEATURE_REDESIGN_SAMPLE_RATE);
}
